export const CALENDAR_YEAR_SHORT = "CY";
export const FISCAL_YEAR_SHORT = "FY";
export const TAX_YEAR_SUFFIX = "Tax Year";

export const FORM_1120_BASE_TASK_KEY = "FORM_1120_US_CORPORATION_INCOME_TAX";
export const FORM_1120S_BASE_TASK_KEY = "FORM_1120S_US_S_CORP_INCOME_TAX";
export const TAX_YEAR_TASK_KEYS: string[] = [
  FORM_1120_BASE_TASK_KEY,
  FORM_1120S_BASE_TASK_KEY,
];
